import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { ClienteService } from 'src/app/services/cliente/cliente.service';
import { BreadcrumbsComponent } from "../../shared/breadcrumbs/breadcrumbs.component";

@Component({
    selector: 'app-buscar-cliente',
    templateUrl: './buscar-cliente.component.html',
    styleUrls: ['./buscar-cliente.component.css'],
    imports: [CommonModule, FormsModule, BreadcrumbsComponent],
    standalone: true
})
export class BuscarClienteComponent implements OnInit {

  searchTerm: string = '';
  clientes: any[] = [];
  usuarioId: number = 0;
  constructor(private clienteService: ClienteService, private currentUserService:CurrentUserService, private router: Router) {}

  buscarClientes() {
    // const usuarioId = this.currentUserService.getUsuarioId();
    // if (!usuarioId) {
    //   alert('Debes iniciar sesión para acceder a esta sección.');
    //   this.router.navigate(['/login']);
    //   return;
    // }
    // this.clienteService.buscarClientes(this.usuarioId,this.searchTerm).subscribe((data) => {
    //   this.clientes = data;
    // });
    this.cargarClientes();
  }

  mostrarLibreta(clienteId: number) {
    this.router.navigate(['/cliente/libreta', clienteId]);
  }

  editarCliente(clienteId: number) {
    this.router.navigate(['/cliente/editar', clienteId]);
  }

 eliminarCliente(id: number) {
  if (!confirm('¿Está seguro de eliminar este cliente?')) return;

  this.clienteService.deleteCliente(id).subscribe({
    next: (res) => {
      console.log('Respuesta:', res);
      alert('Cliente eliminado correctamente');
      this.cargarClientes(); // Recargar la lista de clientes después de eliminar
    },
    error: (err) => {
      console.error(err);
      alert('Error al eliminar cliente');
    }
  });
}

cargarClientes() {
 this.clienteService.buscarClientes(this.usuarioId,this.searchTerm).subscribe((data) => {
      this.clientes = data;
    });
}
  nuevoCliente() {
    this.router.navigate(['/cliente/nuevo']);
  }

  ngOnInit(): void {
    const usuarioId = this.currentUserService.getUsuarioId();
    if (!usuarioId) {
      alert('Debes iniciar sesión para acceder a esta sección.');
      this.router.navigate(['/login']);
      return;
    }
    this.usuarioId += usuarioId;
  }
  volverAtras(): void {
    this.router.navigate(['/dashboard']); 
  }

  verPagos(clienteId: number) {
    this.router.navigate(['/lista-pagos'], { queryParams: { clienteId: clienteId } });
  }
}
